const MAX_TEXT_LENGTH = 1024;

const SENSITIVE_PATTERNS = [
  /(authorization["'\s:=]*bearer\s+)[a-z0-9\-._~+/]+=*/gi,
  /(bearer\s+)[a-z0-9\-._~+/]+=*/gi,
  /([?&](?:token|access_token|id_token|refresh_token|client_secret|password)=)[^&\s]+/gi,
  /((?:token|access_token|id_token|refresh_token|client_secret|password)["'\s:=]+)[^,"'\s]+/gi
];

const safeJsonStringify = (value) => {
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
};

export const redactSensitiveText = (value) => {
  const normalized = String(value ?? "").slice(0, MAX_TEXT_LENGTH);
  return SENSITIVE_PATTERNS.reduce(
    (output, pattern) => output.replace(pattern, "$1[REDACTED]"),
    normalized
  );
};

export const sanitizeEventDetail = (detail = {}) => {
  const sanitized = {};

  Object.entries(detail).forEach(([key, value]) => {
    if (value == null) {
      sanitized[key] = value;
      return;
    }

    if (typeof value === "string") {
      sanitized[key] = redactSensitiveText(value);
      return;
    }

    if (typeof value === "number" || typeof value === "boolean") {
      sanitized[key] = value;
      return;
    }

    sanitized[key] = redactSensitiveText(safeJsonStringify(value));
  });

  return sanitized;
};
